import { ClientService } from "../clients/clientService";
import { FactureService } from "../factures/factureService";
import apiClient from "../api/client";

export const DashboardService = {
  async getAdminStats() {
    const response = await apiClient.get('/analytics/admin-stats/');
    return response.data;
  },

  async getClientDashboardData(clientId: string) {
      try {
          const [statsRes, facturesRes, fournisseursRes] = await Promise.all([
              ClientService.getClientStats(clientId),
              FactureService.getFactures({ limit: 5, client: clientId, ordering: '-created_at' }),
              ClientService.getClientContrats(clientId) // approximation for suppliers/relations
          ]);

          return {
              stats: statsRes.data,
              recentFactures: facturesRes.data,
              contracts: fournisseursRes.data
          };
      } catch (error) {
          console.error("Error fetching client dashboard data", error);
          throw error;
      }
  }
};
